export default __webpack_public_path__ + "static/assets/a6592ba549a17e9afeaaeedc93369d98.jpg";